// Copyright (c) 2019 Deere & Company
import React, { Component } from 'react';
import AuthenticatedPage from '../app/common/components/authenticated-page';
import PartGroupMaintenance from './components/part-group-maintenance';
import PropTypes from 'prop-types';

class PartGroupMaintenancePage extends Component {


    state= {
        navParameter: '',
    }


    componentWillReceiveProps ( nextProps ) {

        if ( nextProps.location.state === 'partGroup' ) {

            this.setState( {
                navParameter: nextProps.location.state,
            } );

        }

    }

    updateReload = () => {

        this.setState( {
            navParameter: '',
        } );

    }

    render = () => (
        <AuthenticatedPage className="admin-page">
            <PartGroupMaintenance
                reload={this.state.navParameter}
                updateReload={this.updateReload}
            />
        </AuthenticatedPage>
    )

}

PartGroupMaintenancePage.displayName = 'PartGroupMaintenancePage';
PartGroupMaintenancePage.propTypes = {
    location: PropTypes.object.isRequired,
};

export default PartGroupMaintenancePage;
